import axios from '../axios'

const patchRescheduleAvailableApi = async (eventId, startAt, endAt) => {
    return await axios.patch(`api/teacher/events/${eventId}/reschedule-available`, { startAt, endAt })
}

export default patchRescheduleAvailableApi